export function isLocalUrl(href: string) {
	return (
		href.includes(String(process.env.GRANLUPO_PROD_URL)) ||
		href.includes(String(process.env.GRANLUPO_BETA_URL)) ||
		href.includes(String(process.env.GRANLUPO_WEB_URL)) ||
		href.includes('kontaktni-formular') ||
		href.startsWith('/') ||
		href.startsWith('#')
	)
}
